import React, { useEffect, useState } from 'react';
export function UrgencyBanner() {
  const [deadline, setDeadline] = useState('');
  useEffect(() => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    const day = tomorrow.getDate();
    const months = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
    const month = months[tomorrow.getMonth()];
    setDeadline(`${day} de ${month}`);
  }, []);
  return <div className="sticky top-0 z-50 w-full bg-brand-red text-white py-3 px-4 shadow-md" data-id="element-368">
      <div className="max-w-7xl mx-auto text-center" data-id="element-369">
        <p className="text-sm md:text-base font-bold tracking-wide" data-id="element-370">
          <span className="animate-pulse inline-block mr-2" data-id="element-371">⏰</span>
          OFERTA DE LANZAMIENTO — Hasta el {deadline}: Acceso completo con todos
          los BONOS incluidos. Después sube de precio.
        </p>
      </div>
    </div>;
}